import { AiseaApiFactory } from "@/api/aisea/apiFactory";
const euApi = AiseaApiFactory.get("enterpriseUser");
const eplApi = AiseaApiFactory.get("enterpriseLicense");
const picApi = AiseaApiFactory.get("picture");
const eplpApi = AiseaApiFactory.get("enterpriseLicensePicture");

export default {

  async fetchUserData({ commit }, payload) {
    let euAddRes = await euApi.fetch(payload.userId);
    commit("SET_USER", euAddRes.data);
    let eplAddRes = await eplApi.fetch(payload.userId);
    commit("SET_USER_LICENSE", eplAddRes.data.licenses);
  },

  async setInputForm({ commit }, payload) {
    commit("SET_INPUT_FORM", payload);
  },

  async setSelectedLicenseCategory({ commit }, payload) {
    commit("SET_SELECTED_LICENSE_CATEGORY", payload);
  },

  async cleanUp({ commit }) {
    commit("CLEAR_INPUT_FORM");
    commit("CLEAR_PICTURE_SRC");
  },

  async setPictureSrc({ commit }, payload) {
    commit("SET_PICTURE_SRC", { pictureSrc: payload });
  },

  async clearPictureSrc({ commit }) {
    commit("CLEAR_PICTURE_SRC");
  },

  async registerLicense({ commit, state }, payload) {
    let eppAddRes = await eplApi.add(payload.userId, state.inputForm);
    commit("SET_REGISTERED_LICENSE", eppAddRes.data);

    if (state.pictureSrc) {
      let formData = new FormData();
      formData.append("data", state.pictureSrc);
      let pRes = await picApi.addLicensePicture({ formData: formData });
      await eplpApi.linkTo(payload.userId, eppAddRes.data.id, {
        id: pRes.data.id
      });
    }
  },

  async resetLicenseAddState({ commit }) {
    let defaultState = {
      user: null,
      userLicense: null,
      selectedLicenseCategory: null,
      inputForm: {},
      pictureSrc: null,
      registeredLicense: null
    };
    commit("RESET_STATE", defaultState);
  }
};
